interface Props {
  index?: string;
  kicker: string;
  title: string;
  desc?: string;
  tone?: 'primary' | 'accent';
}

export default function SectionHead({ index, kicker, title, desc, tone = 'primary' }: Props) {
  const toneDot = tone === 'accent' ? 'bg-accent-500' : 'bg-primary-500';
  return (
    <div className="max-w-2xl">
      <div className="flex items-center gap-2">
        {index && (
          <span className="font-heading text-sm font-bold tracking-wide text-secondary-500">{index}</span>
        )}
        <span className={`flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium tracking-widest ${tone === 'accent' ? 'bg-accent-100 text-accent-900' : 'bg-primary-100 text-primary-800'}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${toneDot}`}></span>
          {kicker}
        </span>
      </div>
      <h2 className="mt-5 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-[34px] md:leading-tight">
        {title}
      </h2>
      {desc && <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}